import { convertArea, convertLength } from '@turf/helpers';
import { FileSizeOptionsBase, FileSizeOptionsString, filesize } from 'filesize';

export const roundNum = (num: number, decimals: number) => {
  return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
};

export const squareMetersToHectares = (value: number, precision: number) => {
  const result = convertArea(value, 'meters', 'hectares');
  const rounded = roundNum(result, precision);
  return rounded.toFixed(precision);
};

export const humanReadableFileSize = (
  fileSize: number,
  options?: FileSizeOptionsString | FileSizeOptionsBase
) => {
  options = options || { standard: 'jedec' };
  return filesize(fileSize, options);
};

export const readableId = (str: string) => {
  const parts = str.split('-');
  let result = '';
  if (parts.length > 1) {
    result = `${parts[0]}-${parts[1]}-${parts[2]}`;
  } else {
    result = str;
  }
  if (result.length > 14) {
    result = `${str.slice(0, 11)}...`;
  }
  return result;
};
